define('views/nav/toc',[
  "globals",
  "backbone",
  "./breadcrumbs",
  "fancytree"
], function (globals, Backbone, BreadcrumbsView) {
  "use strict";

  return Backbone.View.extend({
    nodeClasses: {},

    initialize: function () {
      this.breadcrumbs = new BreadcrumbsView();
      this.tree = this.$("#tree");
      _.bindAll(this, "initFancyTree", "changePage", "updateCommentIndicator");
      globals.content.on("change:toc", this.changePage, this);
      return this.render();
    },

    render: function () {
      var sourceUrl = this.tree.data("source"),
        lazyUrl = this.tree.data("lazy"),
        lastLazy = null;

      this.tree.fancytree({
        activate: this.model.tocActivate,
        aria: true,
        autoCollapse: true,
        activeVisible: true,
        beforeActivate: function () {
          // If a comment is being edited, confirm before leaving page
          var t = document.getElementById("comment-text");
          if (t != null && t.value != null && t.value.length > 0) {
            if (!window.confirm(Messages("comment.leave.confirm"))) {
              return false;
            }
          }
        },
        clickFolderMode: 3, // activate and expand
        icons: false,
        init: this.initFancyTree,
        keydown: _.bind(function (event, data) {
          if (event.keyCode === 13) {
            data.node.setExpanded(!data.node.expanded);
          }
        }),
        source: {
          url: sourceUrl
        },

        lazyLoad: function (e, data) {
          var node = data.node;
          if (lastLazy === node) return false;

          lastLazy = node;

          data.result = {
            url: lazyUrl,
            data: {
              key: node.key,
              version: node.data.version,
              language: node.data.language
            }
          };
        },

        extensions: ["dochub"],
      });

      return this;
    },

    initFancyTree: function () {
      this.tree.fancytree("getTree").activateHref({
        library: $("main").data("library"),
        version: $("main").data("version"),
        language: $("main").data("language"),
        path: $("main").data("path")
      });

      return this;
    },

    changePage: function (contentModel) {
      var t = document.getElementById("comment-text");

      if (t != null && t.value != null && t.value.length > 0) {
        if (!window.confirm(this.confirmMessage)) {
          return this;
        }
      }

      const commentForm = document.getElementById("comment-form");
      if (commentForm != null) commentForm.reset();

      var active = this.tree.fancytree("getActiveNode"),
        tree = this.tree.fancytree("getTree");

      // If the TOC node of the page we're trying to change to is already
      // active, bail out.
      if (active && _.isEqual(contentModel.get("location"), active.data.location)) {
        return false;
      }

      this.expandParentNodes(contentModel.get("toc"), tree);

      return this;
    },

    updateCommentIndicator: function (coll) {
      var node = this.tree.fancytree("getActiveNode");
      node.data.comments = coll.length;

      var openComments = coll.filter(function (comment) {
        var status = comment.get("status");
        return !comment.has("parentId") && (status !== "comment.status.postponed" && status !== "comment.status.wontfix" && status !== "comment.status.closed" && status !== "comment.status.implemented");
      });

      node.data.hasOpenComments = openComments.length > 0;
      node.renderTitle();
      return this;
    },

    updateTocStatus: function (status) {
      var node = this.tree.fancytree("getActiveNode");

      if (node) {
        node.data.status = status;
        node.renderTitle();
      }

      return this;
    },

    expandParentNodes: function (nodekey, tree) {
      const key = nodekey.split("|");
      const path = key[1].split(".");
      var currentpath = "";
      var keyPath = "";
      path.forEach(function (element) {
        if(currentpath.length > 0) {
          currentpath = currentpath + "." + element;
        } else {
          currentpath = element;
        }
        keyPath = keyPath + "/" + key[0] + "|" + currentpath;
      });

      tree.loadKeyPath(keyPath, function (node, status) {
        if (status == "loading")
          node.data.shouldPromptForFilter=false;
        else if (status == "ok")
        {
          node.setExpanded(true).done(function () {
            node.setActive(true);
          });
        }
      });
    }
  });
});

